import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { createElement } from 'react';

import { InvoicePage } from '~/modules/invoice';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import {
  defaultInvoiceListSearch,
  validateInvoiceListSearch,
} from '../-invoiceListSearchParams';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.outgoing, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/outgoing/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/outgoing/',
    ...routeParams,
  }),
  component: () => createElement(InvoicePage, { direction: 'outgoing' }),
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(defaultInvoiceListSearch)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: validateInvoiceListSearch,
});

export const OUTGOING_INVOICES = buildRouteExport({
  Route,
  ...routeParams,
});
